export { default as addinIconsRegistration } from './data/addinsIconsRegistration';
export { default as AddinIcons } from './data/AddinsIcons';
export { ControlIcons } from 'owa-control-icons';
